"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toVideoMetadataArrayConversion = exports.toVideoMetadata = exports.toPlaceMetadata = exports.toSoundMetadata = exports.toLensMetadata = exports.toStoryContext = exports.toStoryConversion = exports.toWebPlayerStoryConversion = exports.toSpotlightSnaps = exports.toContextCards = exports.toSpotlightStory = exports.toWebPlayerStoryTypeConversion = void 0;
const users_1 = require("@snapchat/content-platform-www/generated-src/snapchat/web/stories/users");
const assert_1 = __importDefault(require("assert"));
const props_1 = require("@snapchat/content-platform-www/generated-src/snapchat/web/stories/props");
const fallbacks_1 = require("./types/fallbacks");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const stories_1 = require("./types/stories");
const web_story_web_player_1 = require("@snapchat/web-story-web-player");
const typeConversions_1 = require("./conversion/typeConversions");
const graphql_1 = require("./graphql");
function toSnapUrls(snapUrls) {
    (0, assert_1.default)(snapUrls);
    return {
        mediaUrl: snapUrls.mediaUrl,
        mediaPreviewUrl: snapUrls.mediaPreviewUrl?.value,
        overlayUrl: snapUrls.overlayUrl?.value,
        attachmentUrl: snapUrls.attachmentUrl?.value,
    };
}
/**
 *
 */
function toWebPlayerStoryTypeConversion(playerStoryTypeString) {
    if (playerStoryTypeString === "TYPE_DYNAMIC")
        return web_story_web_player_1.WWWStoryType.DYNAMIC;
    if (playerStoryTypeString === "TYPE_PUBLIC_USER_STORY")
        return web_story_web_player_1.WWWStoryType.PUBLIC_USER;
    if (playerStoryTypeString === "TYPE_MAPS")
        return web_story_web_player_1.WWWStoryType.MAPS;
    if (playerStoryTypeString === "PUBLISHER")
        return web_story_web_player_1.WWWStoryType.PUBLISHER;
    if (playerStoryTypeString === "TYPE_SHARED_OUR_STORY_SNAP")
        return web_story_web_player_1.WWWStoryType.MAPS; // this maps to OUR in the embedded player
    if (playerStoryTypeString === "TYPE_COMMUNITY")
        return web_story_web_player_1.WWWStoryType.SPOTLIGHT;
    return web_story_web_player_1.WWWStoryType.PUBLIC_USER;
}
exports.toWebPlayerStoryTypeConversion = toWebPlayerStoryTypeConversion;
function toStoryType(playerStoryTypeString) {
    if (playerStoryTypeString === "TYPE_DYNAMIC")
        return stories_1.StoryType.DYNAMIC;
    if (playerStoryTypeString === "TYPE_PUBLIC_USER_STORY")
        return stories_1.StoryType.PUBLIC_USER;
    if (playerStoryTypeString === "TYPE_MAPS")
        return stories_1.StoryType.MAPS;
    if (playerStoryTypeString === "PUBLISHER")
        return stories_1.StoryType.PUBLISHER;
    if (playerStoryTypeString === "TYPE_SHARED_OUR_STORY_SNAP")
        return stories_1.StoryType.MAPS; // this maps to OUR in the embedded player
    if (playerStoryTypeString === "TYPE_COMMUNITY")
        return stories_1.StoryType.SPOTLIGHT;
    return stories_1.StoryType.PUBLIC_USER;
}
function toWebPlayerSnapList(snaps) {
    return snaps.map((snap) => ({
        index: snap.snapIndex,
        // eslint-disable-next-line
        id: snap.snapId?.value,
        snapMediaType: (0, typeConversions_1.toSnapMediaTypeForWebPlayer)(users_1.PlayerSnapMediaType[snap.snapMediaType]),
        snapUrls: toSnapUrls(snap.snapUrls),
        isSponsored: snap.isSponsored?.value,
        timestampInSec: snap.timestampInSec && parseInt(snap.timestampInSec.value),
        snapTitle: snap.snapTitle?.value,
        snapSubtitles: snap.snapSubtitles?.value,
        lat: snap.lat?.value,
        lng: snap.lng?.value,
        hasAttachment: snap.hasAttachment?.value,
        intervalStartTimeMs: snap.intervalStartTimeMs && parseInt(snap.intervalStartTimeMs.value),
    }));
}
function toSnapList(playerSnaps) {
    return playerSnaps.map((playerSnap) => {
        const { snapUrls, snapMediaType } = playerSnap;
        const snap = {
            snapUrls: toSnapUrls(snapUrls),
            snapMediaType: (0, typeConversions_1.toSnapMediaType)(users_1.PlayerSnapMediaType[snapMediaType]),
            snapIndex: playerSnap.snapIndex,
            snapId: playerSnap.snapId?.value,
            isSponsored: playerSnap.isSponsored?.value,
            timestampInSec: playerSnap.timestampInSec && parseInt(playerSnap.timestampInSec.value),
            snapTitle: playerSnap.snapTitle?.value,
            snapSubtitles: playerSnap.snapSubtitles?.value,
            lat: playerSnap.lat?.value,
            lng: playerSnap.lng?.value,
            intervalStartTimeMs: playerSnap.intervalStartTimeMs && parseInt(playerSnap.intervalStartTimeMs.value),
        };
        return snap;
    });
}
/**
 *
 */
function toSpotlightStory(incomingFeedItem) {
    const story = incomingFeedItem?.story;
    const meta = incomingFeedItem?.metadata;
    if (incomingFeedItem && story) {
        const jsonStory = {
            story: {
                story_type: stories_1.StoryType.SPOTLIGHT,
                storyId: {
                    value: story.id,
                },
                storyTapId: story.tapId,
                storySubtitle: {
                    value: story.subtitle,
                },
                thumbnailUrl: {
                    value: story.thumbnailUrl,
                },
                storyTitle: {
                    value: story.title,
                },
                canonicalUrlSuffix: {
                    value: story.canonicalUrlSuffix,
                },
                snapList: toSpotlightSnaps(story.snaps),
            },
            metadata: {
                hashtags: meta?.hashtags,
                videoMetadata: {
                    name: meta?.videoMetadata.name,
                    description: meta?.videoMetadata.description,
                    thumbnailUrl: meta?.videoMetadata.thumbnailUrl,
                    uploadDateMs: meta?.videoMetadata.uploadDateMs,
                    contentUrl: meta?.videoMetadata.contentUrl,
                    personCreator: {
                        username: meta?.videoMetadata.creator?.username,
                        url: meta?.videoMetadata.creator?.url,
                    },
                },
                contextCards: toContextCards(meta?.contextCards),
                engagementStats: {
                    viewCount: meta?.engagementStats?.viewCount,
                    shareCount: meta?.engagementStats?.shareCount,
                },
            },
        };
        return props_1.SpotlightStory.fromJSON(jsonStory);
    }
}
exports.toSpotlightStory = toSpotlightStory;
/**
 *
 */
function toContextCards(contextCards) {
    if (!contextCards) {
        return [];
    }
    return contextCards
        .map((contextCard) => props_1.ContextCard.fromJSON({
        contextType: toContextType(contextCard?.contextType),
        title: contextCard?.title,
        subtitle: contextCard?.subtitle,
        url: contextCard?.url,
        thumbnailUrl: contextCard?.thumbnailUrl,
        thumbnailType: toThumbnailType(contextCard?.thumbnailType),
        hasBadge: contextCard?.hasBadge,
        snapcodeUrl: contextCard?.snapcodeUrl,
    }))
        .filter(function (element) {
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        return element !== undefined;
    });
}
exports.toContextCards = toContextCards;
function toContextType(contextType) {
    if (contextType === graphql_1.ContextType.LENS)
        return props_1.ContextType.LENS;
    if (contextType === graphql_1.ContextType.CREATOR)
        return props_1.ContextType.CREATOR;
    if (contextType === graphql_1.ContextType.SOUND)
        return props_1.ContextType.SOUND;
    if (contextType === graphql_1.ContextType.PLACE)
        return props_1.ContextType.PLACE;
    return props_1.ContextType.UNKNOWN_CONTEXT_TYPE_UNSET;
}
function toThumbnailType(thumbnailType) {
    switch (thumbnailType) {
        case graphql_1.ThumbnailType.ICON:
            return props_1.ThumbnailType.ICON;
        case graphql_1.ThumbnailType.WAVEFORM:
            return props_1.ThumbnailType.WAVEFORM;
        default:
            return props_1.ThumbnailType.UNKNOWN_THUMBNAIL_TYPE_UNSET;
    }
}
/**
 *
 */
function toSpotlightSnaps(snaps) {
    return snaps
        .map((snap) => {
        if (snap) {
            const convertedSnap = {
                snapId: {
                    value: snap.id,
                },
                // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                snapMediaType: (0, typeConversions_1.toSnapMediaType)(snap?.snapMediaType.toString()),
                snapUrls: {
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    mediaUrl: snap?.snapUrls?.mediaUrl,
                    mediaPreviewUrl: {
                        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                        value: snap?.snapUrls?.mediaPreviewUrl,
                    },
                },
                snapTitle: {
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    value: snap?.snapTitle,
                },
                snapSubtitles: {
                    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
                    value: snap?.snapSubtitles,
                },
            };
            return users_1.PlayerSnap.fromJSON(convertedSnap);
        }
    })
        .filter((snap) => Boolean(snap));
}
exports.toSpotlightSnaps = toSpotlightSnaps;
/**
 *
 */
function toWebPlayerStoryConversion(story) {
    return {
        type: toWebPlayerStoryTypeConversion(users_1.StoryType[story.storyType]),
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        snaps: toWebPlayerSnapList(story.snapList || []),
        id: story.storyId?.value,
        title: story.storyTitle?.value,
        thumbnailUrl: story.thumbnailUrl?.value,
        storySubtitle: story.storySubtitle?.value,
        storyShareId: story.storyShareId?.value,
        canonicalUrlSuffix: story.canonicalUrlSuffix?.value,
        emoji: story.emoji?.value,
        videoTrackUrl: story.videoTrackUrl?.value,
    };
}
exports.toWebPlayerStoryConversion = toWebPlayerStoryConversion;
/**
 *
 */
function toStoryConversion(playerStory) {
    const { storyType, snapList } = playerStory;
    return {
        storyType: toStoryType(users_1.StoryType[storyType]),
        snapList: toSnapList(snapList),
        storyId: playerStory.storyId?.value,
        storyTitle: playerStory.storyTitle?.value,
        thumbnailUrl: playerStory.thumbnailUrl?.value,
        storySubtitle: playerStory.storySubtitle?.value,
        storyShareId: playerStory.storyShareId?.value,
        canonicalUrlSuffix: playerStory.canonicalUrlSuffix?.value,
        emoji: playerStory.emoji?.value,
        videoTrackUrl: playerStory.videoTrackUrl?.value,
    };
}
exports.toStoryConversion = toStoryConversion;
/**
 *
 */
function toStoryContext(spotlightStory) {
    const spotlightStoryMetadata = (0, fallbacks_1.spotlightStoryMetadataOrDefault)(spotlightStory.metadata);
    const engagementStats = spotlightStoryMetadata.engagementStats;
    const snapId = spotlightStory.story?.snapList[0]?.snapId?.value || "";
    const storyTapId = spotlightStory.story?.storyTapId;
    const storyType = spotlightStory.story
        ? toStoryType(users_1.StoryType[spotlightStory.story.storyType])
        : "";
    return {
        snapId,
        storyTapId,
        storyType,
        creatorMetadata: toCreatorMetadata(spotlightStoryMetadata.contextCards),
        hashTags: spotlightStoryMetadata.hashtags,
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        lensMetadata: toLensMetadata(spotlightStoryMetadata.contextCards),
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        musicMetadata: toSoundMetadata(spotlightStoryMetadata.contextCards),
        placeMetadata: toPlaceMetadata(spotlightStoryMetadata.contextCards),
        viewCount: engagementStats?.viewCount
            ? (0, web_core_ui_1.prettyPrintNumberWithNoZeros)(parseInt(engagementStats.viewCount))
            : undefined,
        shareCount: engagementStats?.shareCount
            ? (0, web_core_ui_1.prettyPrintNumberWithNoZeros)(parseInt(engagementStats.shareCount))
            : undefined,
        description: spotlightStoryMetadata.description,
    };
}
exports.toStoryContext = toStoryContext;
/**
 *
 */
function toLensMetadata(contextCards) {
    const lensContextCard = contextCards.find((card) => (0, props_1.contextTypeFromJSON)(card.contextType) === props_1.ContextType.LENS);
    if (lensContextCard) {
        return {
            iconUrl: lensContextCard.thumbnailUrl,
            unlockUrl: lensContextCard.url,
            creatorName: lensContextCard.subtitle,
            lensName: lensContextCard.title,
        };
    }
}
exports.toLensMetadata = toLensMetadata;
/**
 *
 */
function toSoundMetadata(contextCards) {
    const soundContextCard = contextCards.find((card) => (0, props_1.contextTypeFromJSON)(card.contextType) === props_1.ContextType.SOUND);
    if (soundContextCard) {
        return {
            songName: soundContextCard.title,
            artistName: soundContextCard.subtitle,
            iconUrl: soundContextCard.thumbnailUrl,
        };
    }
}
exports.toSoundMetadata = toSoundMetadata;
/**
 *
 */
function toPlaceMetadata(contextCards) {
    const placeContextCard = contextCards.find((card) => (0, props_1.contextTypeFromJSON)(card.contextType) === props_1.ContextType.PLACE);
    if (placeContextCard) {
        return {
            placeName: placeContextCard.title,
            placeType: placeContextCard.subtitle,
            iconUrl: placeContextCard.thumbnailUrl,
            url: placeContextCard.url,
        };
    }
}
exports.toPlaceMetadata = toPlaceMetadata;
function toCreatorMetadata(contextCards) {
    const creatorContextCard = contextCards.find((card) => (0, props_1.contextTypeFromJSON)(card.contextType) === props_1.ContextType.CREATOR);
    if (creatorContextCard) {
        const isCreatorPublisher = !creatorContextCard.url.includes("/add");
        return isCreatorPublisher
            ? {
                displayName: creatorContextCard.title,
                url: creatorContextCard.url,
                profilePictureUrl: creatorContextCard.thumbnailUrl,
            }
            : {
                displayName: creatorContextCard.title,
                username: creatorContextCard.subtitle,
                url: creatorContextCard.url,
                profilePictureUrl: creatorContextCard.thumbnailUrl,
                hasBadge: creatorContextCard.hasBadge,
                emoji: "",
            };
    }
    else {
        return {
            ...fallbacks_1.DEFAULT_USER_DISPLAY_INFO,
            url: "https://www.snapchat.com/download/",
        };
    }
}
/**
 *
 */
function toVideoMetadata(metadata, videoMetadata) {
    if (!metadata || !videoMetadata) {
        return undefined;
    }
    const creatorCard = metadata.contextCards.find((card) => (0, props_1.contextTypeFromJSON)(card.contextType) === props_1.ContextType.CREATOR);
    return {
        ...videoMetadata,
        ...(videoMetadata.creator?.$case === "personCreator" &&
            creatorCard && {
            creator: {
                ...videoMetadata.creator,
                personCreator: {
                    ...videoMetadata.creator.personCreator,
                    name: creatorCard.title,
                    url: creatorCard.url,
                },
            },
        }),
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        keywords: metadata.hashtags || [],
        shareCount: metadata.engagementStats?.shareCount || videoMetadata.shareCount,
    };
}
exports.toVideoMetadata = toVideoMetadata;
/**
 *
 */
function toVideoMetadataArrayConversion(spotlightStoryMetadata) {
    if (!spotlightStoryMetadata) {
        return undefined;
    }
    const numOfVideo = 10;
    const videoMetadata = [];
    // eslint-disable-next-line no-restricted-properties
    spotlightStoryMetadata.forEach((spotlightStory) => {
        if (videoMetadata.length >= numOfVideo) {
            return videoMetadata;
        }
        if (spotlightStory.videoMetadata !== undefined) {
            videoMetadata.push(spotlightStory.videoMetadata);
        }
    });
    return videoMetadata;
}
exports.toVideoMetadataArrayConversion = toVideoMetadataArrayConversion;
//# sourceMappingURL=conversions.js.map